// https://github.com/GoogleChrome/dialog-polyfill
import dialogPolyfill from 'dialog-polyfill';

const getDialog = (root = document.body, selector = 'dialog') => {
	const dialog = root.querySelector(selector);

	if (dialog) {
		dialogPolyfill.registerDialog(dialog);
	}

	return dialog;
};

export default getDialog;
